import css from './BannerCondia.module.css'

export default function BannerConfia(){
    return(
        <div className={css.div}>
            <p className={css.p1}>Quem compra,</p>
            <p className={css.p2}>recomenda!</p>
        </div>
    )
}